var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { h, Component } from 'preact';
import { dispatchGlobalEvent } from '../../services/UtilsTool';
import SrwrdsLogo from '../SrwrdsLogo/SrwrdsLogo';
import { inContext, disabledClickDelay } from '../../services/UtilsTool';
import SrwrdsLogoMobile from '../SrwrdsLogo/SrwrdsLogoMobile';
import './Start.scss';
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.srwrdsStartDisabled = false;
        _this.labels = {
            start: _this.props.label,
            join: _this.props.join,
        };
        _this.imagePaths = {
            chestsOpen: require('../../../public/starsreward_chest_open@2x.png'),
        };
        return _this;
    }
    Dropdown.prototype.getLocalisation = function (id) {
        return this.labels[id];
    };
    /**
     * Sets the status of the disabled flag and forces a re-render of the component.
     */
    Dropdown.prototype.setDisabledStatus = function (event, status) {
        this[event + "Disabled"] = status;
        this.forceUpdate();
    };
    Dropdown.prototype.dispatchGlobalEvt = function (event) {
        var _this = this;
        this.setDisabledStatus(event, true);
        setTimeout(function () {
            dispatchGlobalEvent(event);
        }, 1); // remove from the call stack to allow a slight delay in sending the event.
        setTimeout(function () {
            _this.setDisabledStatus(event, false);
        }, disabledClickDelay);
    };
    Dropdown.prototype.render = function (props) {
        var _this = this;
        // console.log('PROPS:', this.props);
        var isMobileCasino = inContext('CASINO-MOBILEWEB');
        var isBarOnly = inContext('BAR');
        return (h("div", { className: "srwrds-init" },
            !this.props.casino && !isBarOnly ? h(SrwrdsLogo, null) : null,
            h("div", { className: "srwrds-join" },
                h("div", { className: "srwrds-chests-open" },
                    h("img", { src: this.imagePaths.chestsOpen })),
                h("div", { className: "srwrds-text" }, this.getLocalisation('join'))),
            isMobileCasino ? h(SrwrdsLogoMobile, null) : null,
            h("div", { className: "srwrds-btn", onClick: function () {
                    !_this.srwrdsStartDisabled
                        ? _this.dispatchGlobalEvt(Dropdown.EVENTS.START)
                        : '';
                } },
                this.props.casino && !inContext('CASINO-MOBILEWEB') ? (h("svg", { "data-id": "srwrds-star", viewBox: "0 0 54.68 30", preserveAspectRatio: "xMidYMid meet" },
                    h("path", { d: "M23.46,10.87a.52.52,0,0,0,.49-.35L27.36,0l3.42,10.51a.51.51,0,0,0,.49.35h11l-8.94,6.5a.52.52,0,0,0-.21.42.46.46,0,0,0,0,.16l3.42,10.51L27.6,22A.52.52,0,0,0,27,22L18,28.45l3.41-10.51a.48.48,0,0,0,0-.16.52.52,0,0,0-.21-.42l-8.94-6.5Z", fill: "#e11b22" }),
                    h("path", { d: "M25.78,13.68a.21.21,0,0,0,.2-.14l1.39-4.27,1.39,4.27a.21.21,0,0,0,.2.14h4.49l-3.64,2.64a.21.21,0,0,0-.09.17.19.19,0,0,0,0,.06l1.39,4.27-3.64-2.64a.21.21,0,0,0-.25,0l-3.63,2.64L25,16.56a.22.22,0,0,0,0-.06.21.21,0,0,0-.09-.17l-3.63-2.64Z", fill: "#fff" }),
                    h("path", { d: "M7.55,18a.35.35,0,0,0,.34-.24l2.33-7.19,2.34,7.19a.35.35,0,0,0,.33.24h7.56l-6.12,4.45a.36.36,0,0,0-.15.29.31.31,0,0,0,0,.11L16.55,30l-6.12-4.45a.35.35,0,0,0-.42,0L3.9,30l2.34-7.19a.33.33,0,0,0,0-.11.36.36,0,0,0-.15-.29L0,18Z", fill: "#e11b22" }),
                    h("path", { d: "M9.14,19.9a.14.14,0,0,0,.14-.1l1-2.92,1,2.92a.14.14,0,0,0,.14.1h3.07L12,21.71a.14.14,0,0,0-.06.12h0l1,2.92L10.31,23a.14.14,0,0,0-.17,0L7.65,24.8l1-2.92h0a.14.14,0,0,0-.06-.12L6.06,19.9Z", fill: "#fff" }),
                    h("path", { d: "M41.78,18a.35.35,0,0,0,.34-.24l2.33-7.19,2.34,7.19a.35.35,0,0,0,.33.24h7.56l-6.12,4.45a.36.36,0,0,0-.15.29.31.31,0,0,0,0,.11L50.77,30l-6.12-4.45a.35.35,0,0,0-.42,0L38.12,30l2.34-7.19a.33.33,0,0,0,0-.11.36.36,0,0,0-.15-.29L34.21,18Z", fill: "#e11b22" }),
                    h("path", { d: "M43.36,19.9a.14.14,0,0,0,.14-.1l.95-2.92,1,2.92a.14.14,0,0,0,.14.1h3.07l-2.49,1.81a.14.14,0,0,0-.06.12h0l1,2.92L44.53,23a.14.14,0,0,0-.17,0l-2.49,1.8,1-2.92h0a.14.14,0,0,0-.06-.12L40.28,19.9Z", fill: "#fff" }))) : (h("svg", { viewBox: "0 0 32 32" },
                    h("path", { fill: "#FFFFFF", d: "M21.9,18.5c0.1-0.1,6.9-5,8.8-6.4l0.8-0.6H19.6c-0.1,0-0.2,0-0.2-0.1c0,0-2.6-8.1-3.4-10.4l-0.3-1l-0.3,1 c-0.7,2.3-3.3,10.3-3.4,10.4c0,0.1-0.1,0.1-0.2,0.1H0l0.8,0.6c1.9,1.4,8.8,6.4,8.8,6.4c0.1,0,0.1,0.1,0.1,0.2c0,0,0,0,0,0.1L6,30 l0.8-0.6C8.8,28,15.7,23,15.7,23c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,6.9,5,8.8,6.4l0.8,0.6l-0.3-1c-0.7-2.3-3.4-10.4-3.4-10.4 c0,0,0,0,0,0C21.8,18.6,21.9,18.5,21.9,18.5z M18.1,17.4c0,0,1.1,3.3,1.4,4.2c-0.8-0.6-3.6-2.6-3.6-2.6c-0.1-0.1-0.2-0.1-0.2,0 c0,0-2.8,2-3.6,2.6c0.3-0.9,1.4-4.2,1.4-4.2c0,0,0,0,0-0.1c0-0.1,0-0.1-0.1-0.2c0,0-2.8-2-3.6-2.6h4.4c0.1,0,0.2-0.1,0.2-0.1 c0,0,1.1-3.3,1.4-4.2c0.3,0.9,1.4,4.2,1.4,4.2c0,0.1,0.1,0.1,0.2,0.1h4.4c-0.8,0.6-3.6,2.6-3.6,2.6C18.1,17.2,18.1,17.3,18.1,17.4 C18.1,17.4,18.1,17.4,18.1,17.4z" }))),
                this.props.nudge ? h("span", { className: "srwrds-nudge" }, "!") : null,
                this.getLocalisation('start'))));
    };
    Dropdown.EVENTS = {
        START: 'srwrdsStart',
    };
    return Dropdown;
}(Component));
export default Dropdown;
